export enum MaxImageSizes {
  IMAGE = 1080,
  BACKGROUND_IMAGE = 2500
}
